export default __webpack_public_path__ + "static/media/gb-logo-linear-green.8c2fd67e.svg";